<template>
  <DragDialog
    title="分配角色"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="assign-role-box">
      <div class="item">
        <p class="label dialog-label">用户账号</p>
        <div
          v-if="userList.length === 1"
          class="single-tag-box">
          <div class="tag-name dialog-label">
            {{ userList[0].surname }}
          </div>
        </div>
        <div
          class="tag-box"
          v-else>
          <div
            class="tag-item-box"
            v-for="(item, index) in userList"
            :key="index">
            <div class="tag-name dialog-label">
              {{ item.surname }}
            </div>
            <div
              class="icon-box"
              @click="removeUser(item)">
              <i class="el-icon-close" />
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <p class="label dialog-label">搜索角色</p>
        <div class="common-input-box">
          <el-input
            class="input-primary"
            placeholder="请输入角色名称"
            v-model="keywords"
            clearable
            @clear="queryRoleList"
            @keyup.enter.native="queryRoleList">
            <i
              slot="suffix"
              class="el-input__icon el-icon-search"
              @click="queryRoleList" />
          </el-input>
        </div>
      </div>
      <div class="common-table-box assign-role-table">
        <el-table
          class="publish-table"
          :header-row-class-name="customHeader"
          :data="roleList"
          height="100%"
          ref="rolesTable">
          <el-table-column width="55">
            <template v-slot="{ row }">
              <el-radio
                class="radio-primary"
                v-model="selectRoleId"
                :label="row.roleId" />
            </template>
          </el-table-column>
          <el-table-column
            label="角色名称"
            prop="roleName"
            width="220" />
          <el-table-column
            label="角色说明"
            prop="description" />
        </el-table>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { Store } from '@/utils/store'
import { getUserRoleList, assignRoles } from '@/service/interface'

export default {
  data() {
    return {
      keywords: '',
      roleList: [],
      selectRoleId: '',
      userList: [],
      customHeader: ''
    }
  },
  props: {
    visible: Boolean,
    selectUsers: Array,
    roleId: String,
    closeDialog: Function,
    queryUserList: Function
  },
  components: {
    DragDialog
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.rolesTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 500)
  },
  watch: {
    roleId: function (newValue) {
      if (newValue) {
        this.selectRoleId = newValue
        this.userList = JSON.parse(JSON.stringify(this.selectUsers))
      }
    },
    visible: function (newValue) {
      if (newValue && this.isChecked('User.UpdateRole')) {
        this.queryRoleList()
      }
      if (newValue) {
        setTimeout(() => {
          const currentBody = this.$refs.rolesTable?.bodyWrapper
          currentBody &&
            currentBody.addEventListener('scroll', ev => {
              const scrollTop = ev.target.scrollTop
              this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
            })
        }, 500)
      }
    }
  },
  methods: {
    removeUser(userInfo) {
      if (this.userList.length === 1) {
        this.$message.warning('分配角色至少要有一位用户')
        return
      }

      let findIndex = this.userList.findIndex(
        el => el.userId === userInfo.userId
      )
      if (findIndex !== -1) {
        this.userList.splice(findIndex, 1)
      }
    },
    submit() {
      let userIds = this.userList.map(el => el.userId)
      let roleInfo = this.roleList.find(el => el.roleId === this.selectRoleId)
      let params = {
        userIds,
        roleCode: roleInfo.roleCode
      }
      assignRoles(params).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            this.queryUserList().then(() => {
              this.$message.success('分配角色成功！！！')

              this.cancel()
            })
          } else {
            this.$message.error(response.errMsg)
          }
        }
      })
    },
    cancel() {
      this.keywords = ''
      this.roleList = []
      this.selectRoleId = ''
      this.userList = []
      this.closeDialog()
    },
    queryRoleList() {
      let params = { roleName: this.keywords }
      getUserRoleList(params).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            let roleList = response.data
            this.roleList = roleList
          } else {
            this.$message.error(response.errMsg)
          }
        }
      })
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less">
.assign-role-box {
  color: var(--default-color);
  .el-tag {
    margin-right: 10px;
    border: none;
    color: var(--default-color);
  }

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .common-input-box {
      height: 32px;

      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }

      .el-input__icon {
        line-height: 32px;
      }
    }

    .label {
      flex-shrink: 0;
      width: 80px;
      text-align: left;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      padding: 5px;
      font-size: 14px;
      max-height: 150px;
      overflow-y: auto;
      background: var(--input-bg-color);

      .tag-item-box {
        display: flex;
        padding: 4px 8px;
        background: var(--base-bg-light-color24);
        border-radius: 4px;

        .tag-name {
          font-size: 14px;
          color: var(--base-primary-bgColor);
        }

        .icon-box {
          margin-left: 5px;
          color: var(--base-dark10-color);
          cursor: pointer;
        }
      }
    }

    .single-tag-box {
      display: flex;
      padding: 5px 10px;
      padding-left: 0;
      border-radius: 2px;

      .tag-name {
        font-size: 14px;
      }

      .icon-box {
        margin-left: 5px;
        color: var(--base-dark10-color);
        cursor: pointer;
      }
    }

    .search-input {
      width: 200px;
    }
  }

  .assign-role-table {
    height: 300px;
    overflow-y: auto;

    .el-radio__label {
      display: none;
    }

    .el-table_2_column_13 {
      .cell {
        padding-left: 25px;
      }
    }
  }
}
</style>
